import styled from "styled-components"

export const TermsAndConditionsContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;

    * {
        color: ${(props) => props.theme.color.newGray}
    }
`

export const Confirmation = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: unset;
    padding-top: 2rem;
    padding-bottom: 2rem;
    margin: 0 auto;
`

export const CheckboxWrap = styled.div`
    margin-right: 1rem;
`



// WEBPACK FOOTER //
// ./src/pages/AffiliateRegistration/TermsAndConditions/styled.js